import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { configure } from 'mobx';
import theme from './theme';
import KeyboardShortcuts from './KeyboardShortcuts';
import NotificationBar from './NotificationBar';
import App from './App';
import './Trackers';
/*
import e2eInstance from './lib/axios';
e2eInstance.interceptors.response.use(
  response => {
    const now = Date.now();
    console.log(response);

    return response;
  },
  error => Promise.reject(error)
);
*/
configure({ enforceActions: false }); // strict mode

/* DISABLE GOOGLE MAPS LOADING FONTS AND REFRESHING PAGE */
const head = document.getElementsByTagName('head')[0];
const { insertBefore } = document.head;
document.head.insertBefore = (newElement, referenceElement) => {
  if (
    newElement.href &&
    newElement.href.indexOf('//fonts.googleapis.com/css?family=Roboto') > -1
  ) {
    return;
  }

  insertBefore.call(head, newElement, referenceElement);
};
/* END OF DISABLE GOOGLE MAPS LOADING FONTS AND REFRESHING PAGE */

const rootNode = document.getElementById('root');
const root = ReactDOM.createRoot(rootNode);

root.render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <NotificationBar />

      <CssBaseline />
      <BrowserRouter>
        <KeyboardShortcuts>
          <App />
        </KeyboardShortcuts>
      </BrowserRouter>
    </ThemeProvider>
  </StyledEngineProvider>
);
